import { useState, useEffect } from "react";
import { Button } from "@oc-labs/wt-storybook";
import ModalV2 from "../../../../components/ModalV2";
import useModal from "../../../../hooks/useModal";

export default function ColorEditModal({ company, onSave }) {
  const modal = useModal("editColors");
  const [colors, setColors] = useState({
    primaryColor: company?.primaryColor || "#2B36D9",
    secondaryColor: company?.secondaryColor || "#E3E3E3",
    accentColor: company?.accentColor || "#2B36D9",
    primaryTextColor: company?.primaryTextColor || "#000000",
    secondaryTextColor: company?.secondaryTextColor || "#000000",
    accentTextColor: company?.accentTextColor || "#FFFFFF",
    secondaryButtonTextColor: company?.secondaryButtonTextColor || "#000000",
    linkColor: company?.linkColor || "#0000FF",
  });

  const [customColorInputs, setCustomColorInputs] = useState({
    primaryColor: "",
    secondaryColor: "",
    accentColor: "",
    primaryTextColor: "",
    secondaryTextColor: "",
    accentTextColor: "",
    secondaryButtonTextColor: "",
    linkColor: "",
  });

  useEffect(() => {
    if (modal.isOpen) {
      setColors({
        primaryColor: company?.primaryColor || "#2B36D9",
        secondaryColor: company?.secondaryColor || "#E3E3E3",
        accentColor: company?.accentColor || "#2B36D9",
        primaryTextColor: company?.primaryTextColor || "#000000",
        secondaryTextColor: company?.secondaryTextColor || "#000000",
        accentTextColor: company?.accentTextColor || "#FFFFFF",
        secondaryButtonTextColor: company?.secondaryButtonTextColor || "#000000",
        linkColor: company?.linkColor || "#0000FF",
      });
      setCustomColorInputs({
        primaryColor: "", secondaryColor: "", accentColor: "",
        primaryTextColor: "", secondaryTextColor: "", accentTextColor: "",
        secondaryButtonTextColor: "", linkColor: "",
      });
    }
  // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [modal.isOpen]);

  const colorLabels = {
    primaryColor: "Primary Color",
    secondaryColor: "Secondary Color",
    accentColor: "Accent Color",
    primaryTextColor: "Primary Text Color",
    secondaryTextColor: "Secondary Text Color",
    accentTextColor: "Primary Button Text Color",
    secondaryButtonTextColor: "Secondary Button Text Color",
    linkColor: "Link Color",
  };

  const handleColorChange = (key, value) => {
    setColors((prev) => ({ ...prev, [key]: value }));
    setCustomColorInputs((prev) => ({ ...prev, [key]: "" }));
  };

  const handleCustomColorChange = (key, value) => {
    setCustomColorInputs((prev) => ({ ...prev, [key]: value }));
    if (/^#[0-9A-F]{6}$/i.test(value)) {
      setColors((prev) => ({ ...prev, [key]: value }));
    }
  };

  const handleSave = () => {
    onSave?.(colors);
    modal.close();
  };

  return (
    <ModalV2 name="editColors" title="Wallet Color Settings">
      <div className="space-y-4 mt-4">
        <p className="text-sm text-gray-600">Configure the colors for your wallet</p>

        <div className="grid grid-cols-2 gap-6 px-4">
          <div className="space-y-4">
            {Object.entries(colorLabels).slice(0, 4).map(([key, label]) => (
              <div key={key}>
                <label className="text-sm font-medium text-gray-700">{label}</label>
                <div className="flex items-center gap-2">
                  <input
                    type="color"
                    value={colors[key]}
                    onChange={(e) => handleColorChange(key, e.target.value)}
                    className="w-12 h-10 rounded cursor-pointer"
                  />
                  <input
                    type="text"
                    value={customColorInputs[key] || colors[key]}
                    onChange={(e) => handleCustomColorChange(key, e.target.value)}
                    placeholder="#RRGGBB"
                    className="flex-1 px-3 py-2 border border-gray-300 rounded text-sm"
                  />
                </div>
              </div>
            ))}
          </div>
          <div className="space-y-4">
            {Object.entries(colorLabels).slice(4, 8).map(([key, label]) => (
              <div key={key}>
                <label className="text-sm font-medium text-gray-700">{label}</label>
                <div className="flex items-center gap-2">
                  <input
                    type="color"
                    value={colors[key]}
                    onChange={(e) => handleColorChange(key, e.target.value)}
                    className="w-12 h-10 rounded cursor-pointer"
                  />
                  <input
                    type="text"
                    value={customColorInputs[key] || colors[key]}
                    onChange={(e) => handleCustomColorChange(key, e.target.value)}
                    placeholder="#RRGGBB"
                    className="flex-1 px-3 py-2 border border-gray-300 rounded text-sm"
                  />
                </div>
              </div>
            ))}
          </div>
        </div>

        <div className="flex justify-center mt-8 px-8 mb-8 gap-4">
          <button
            type="button"
            onClick={() => {
              const defaultColors = {
                primaryColor: '#2B36D9',
                secondaryColor: '#E3E3E3',
                accentColor: '#2B36D9',
                primaryTextColor: '#000000',
                secondaryTextColor: '#000000',
                accentTextColor: '#FFFFFF',
                secondaryButtonTextColor: '#000000',
                linkColor: '#0000FF',
              };
              setColors(defaultColors);
              setCustomColorInputs({
                primaryColor: '',
                secondaryColor: '',
                accentColor: '',
                primaryTextColor: '',
                secondaryTextColor: '',
                accentTextColor: '',
                secondaryButtonTextColor: '',
                linkColor: '',
              });
              onSave?.(defaultColors);
              modal.close();
            }}
            className="px-8 py-2 rounded-3xl bg-gray-200 text-black font-medium hover:bg-gray-300 transition whitespace-nowrap cursor-pointer"
          >
            Reset to Default
          </button>
          <Button type="primary" onClick={handleSave} className="px-8">
            Save Changes
          </Button>
        </div>
      </div>
    </ModalV2>
  );
}
